<template>
  <div>
    <GroupsPupils :items="groups" v-model="group_id" />
  </div>
</template>
<script>
import { getGroups, getClients } from "@/_api/apiPupil";
import groups from "@/components/Pupils/Groups";
import GroupsPupils from "@/components/Pupils/GroupsPupils";

import chat from "@/components/Pupils/Chat";
import journal from "@/components/Pupils/Journal";
import timetable from "@/components/Pupils/Timetable";
import conference from "@/components/Pupils/Conference";
import notifications from "@/components/Pupils/Notifications";
import Decisions from "@/components/Pupils/Decisions";
export default {
  name: "pupils",
  methods: {
    getGroups: getGroups,

  },
  components: {
    groups,
    GroupsPupils,
    chat,
    journal,
    conference,
    notifications,
    Decisions,
    timetable,
  },
  watch: {
    group_id(val) {
      this.isShow = false;

      setTimeout(() => {
        this.isShow = true;
      }, 20);
    },
  },
  mounted() {
    console.log(this.nav)
    if (this.$route.query.group_id) {
      this.group_id = this.$route.query.group_id;
    }
    if (this.$route.query.nav) {
      this.nav = this.$route.query.nav;
    }
    this.isShow = true;
    this.getGroups();
  },
  data() {
    return {
      isShow: false,
      groups: [],
      group_id: null,
      nav: "journal",
    };
  },
};
</script>

